import { HTTP_GET, HTTP_POST, WebApiRequest, HTTP_PUT, HTTP_DELETE } from "tools/webservice";
import regionApi from "apis/region";
import { CountyDto, StateDto, StateRequestDto, ZipCodeDto } from "interfaces/Mueller.Business.Models";

export const getStates = (successCallback: (stateList: StateDto[]) => void, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: regionApi.getStates(),
  successCallback,
  mountedRef,
});

export const getCounties = (stateList: StateRequestDto, successCallback: (countyList: CountyDto[]) => void, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: regionApi.getCounties(),
  payload: stateList,
  successCallback,
  mountedRef,
});

export const getZipCodes = (stateList: StateRequestDto, successCallback: (zipList: ZipCodeDto[]) => void, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: regionApi.getZipCodes(),
  payload: stateList,
  successCallback,
  mountedRef,
});

export const addCountyToServiceRegion = (serviceRegionId, countyId, successCallback, errorCallback, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: regionApi.updateCounty(serviceRegionId, countyId),
  successCallback,
  errorCallback,
  mountedRef,
});

export const removeCountyFromServiceRegion = (serviceRegionId, countyId, successCallback, errorCallback, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: regionApi.updateCounty(serviceRegionId, countyId),
  successCallback,
  errorCallback,
  mountedRef,
});

export const getCountiesForServiceRegion = (id, successCallback, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: regionApi.getCountiesForServiceRegion(id),
  successCallback,
  mountedRef,
});

export const getCountyPostalCodes = (stateList: StateRequestDto, successCallback, mountedRef: React.Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: regionApi.getCountyPostalCodes(),
  payload: stateList,
  successCallback,
  mountedRef,
});

export const getAssignedServiceRegionsByEmployeeId = (employeeId: number, successCallback: (regions: CountyDto[]) => void, mountedRef: React.Ref<boolean>, errorCallback: () => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/regions/employees/${employeeId}`,
  successCallback,
  mountedRef,
  errorCallback,
});
